export enum LayoutTypes {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
  TWOCOLUMN = "twocolumn",
  SEMIBOX = "semibox",
}

export enum LayoutModeTypes {
  LIGHTMODE = "light",
  DARKMODE = "dark",
}
